export default __webpack_public_path__ + "static/media/GreatVibes-Regular.e45e6e2d.ttf";